import { render, staticRenderFns } from "./EditStudent.vue?vue&type=template&id=44f0758e&scoped=true"
import script from "./EditStudent.vue?vue&type=script&lang=js"
export * from "./EditStudent.vue?vue&type=script&lang=js"
import style0 from "./EditStudent.vue?vue&type=style&index=0&id=44f0758e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f0758e",
  null
  
)

export default component.exports